import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditAlterationOrders = () => {
    const [formData, setFormData] = useState({
        counter: '',
        voucher_no: '',
        date: '',
        customer: '',
        trial_date: '',
        delivery_date: '',
        description: '',
        no_of_pcs: '',
        charges_on_delivery: '',
        alteration_description: '',
    });
    
    const { id } = useParams(); // Get the id from the URL params
    const navigate = useNavigate();

    // Fetch the existing alteration order data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}alterationorders/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setFormData(data.data); // Pre-fill form with existing data
                }
            })
            .catch((error) => {
                console.error('Error fetching alteration order:', error);
                alert('Failed to fetch alteration order details');
            });
    }, [id]);

    // Handle input field changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        // Send a PUT request to update the alteration order
        fetch(`${BASE_URL}alterationorders/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Alteration order updated successfully');
                    navigate('/AlterationOrdersList'); // Redirect to the list of alteration orders
                } else {
                    alert('Failed to update alteration order');
                }
            })
            .catch((error) => {
                console.error('Error updating alteration order:', error);
                alert('An error occurred while updating the alteration order');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Alteration Order</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form for editing alteration order */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2">
                        <div className="card">
                            <div className="card-header">
                                <h4>Modify Alteration Order Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="counter" className="form-label">Counter</label>
                                        <input
                                            type="text"
                                            id="counter"
                                            name="counter"
                                            className="form-control"
                                            value={formData.counter}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="voucher_no" className="form-label">Voucher No</label>
                                        <input
                                            type="text"
                                            id="voucher_no"
                                            name="voucher_no"
                                            className="form-control"
                                            value={formData.voucher_no}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            name="date"
                                            className="form-control"
                                            value={formData.date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customer" className="form-label">Customer</label>
                                        <input
                                            type="text"
                                            id="customer"
                                            name="customer"
                                            className="form-control"
                                            value={formData.customer}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="trial_date" className="form-label">Trial Date</label>
                                        <input
                                            type="date"
                                            id="trial_date"
                                            name="trial_date"
                                            className="form-control"
                                            value={formData.trial_date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="delivery_date" className="form-label">Delivery Date</label>
                                        <input
                                            type="date"
                                            id="delivery_date"
                                            name="delivery_date"
                                            className="form-control"
                                            value={formData.delivery_date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            name="description"
                                            className="form-control"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="no_of_pcs" className="form-label">No of Pieces</label>
                                        <input
                                            type="number"
                                            id="no_of_pcs"
                                            name="no_of_pcs"
                                            className="form-control"
                                            value={formData.no_of_pcs}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="charges_on_delivery" className="form-label">Charges on Delivery</label>
                                        <input
                                            type="number"
                                            id="charges_on_delivery"
                                            name="charges_on_delivery"
                                            className="form-control"
                                            value={formData.charges_on_delivery}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="alteration_description" className="form-label">Alteration Description</label>
                                        <input
                                            type="text"
                                            id="alteration_description"
                                            name="alteration_description"
                                            className="form-control"
                                            value={formData.alteration_description}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Update Order</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditAlterationOrders;
